/*!
=========================================================
* Painel Toca da Onça — Networking (aniversário de empresas)
=========================================================
* Empresas que fazem aniversário de FUNDAÇÃO hoje (dado público de CNPJ).
* Felicita pra fazer network B2B. Usar com contatos reais, throttled (anti-ban).
*/
import React from "react";
import { Card, CardHeader, CardBody, CardTitle, Row, Col, Badge, Button } from "reactstrap";

const MODELO =
  "Olá! Passando pra felicitar a [nome] por essa grande bravura de mais um ano de história! 🎉 " +
  "Que Deus abençoe o caminho de vocês. Somos a Toca da Onça Modas e estamos por aqui pra trocar " +
  "experiência e fazer network — se fizer sentido, será um prazer conversar. Sucesso sempre! 🐆";

function NetworkingEmpresas() {
  const [dados, setDados] = React.useState(null);
  React.useEffect(() => {
    fetch("/empresas_aniversario.json", { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then(setDados)
      .catch(() => {});
  }, []);
  const lista = (dados && dados.empresas) || [];
  const exemplo = dados && dados.modo === "exemplo";

  return (
    <div className="content">
      <Row>
        <Col xs="12">
          <h3 className="text-white" style={{ fontWeight: 300 }}>Networking — aniversário de empresas</h3>
          <p className="text-muted">
            Empresas do ramo que fazem aniversário de fundação hoje. Felicitar abre porta pra
            parceria e fornecedor novo.
          </p>
          <div style={{ background: "rgba(255,77,94,.1)", border: "1px solid rgba(255,77,94,.35)", borderRadius: 10, padding: "10px 14px", marginBottom: 8 }}>
            <span className="text-danger">
              <i className="tim-icons icon-alert-circle-exc" /> Anti-ban: felicite POUCAS por dia e com intervalo (empresas com quem faz sentido). Blast em massa = WhatsApp banido.
            </span>
          </div>
          {exemplo && (
            <div style={{ background: "rgba(255,176,32,.12)", border: "1px solid rgba(255,176,32,.4)", borderRadius: 10, padding: "10px 14px", marginBottom: 8 }}>
              <span className="text-warning">
                <i className="tim-icons icon-alert-circle-exc" /> Exemplos — a lista real é gerada quando a base de CNPJ terminar de processar.
              </span>
            </div>
          )}
        </Col>
      </Row>

      <Row>
        <Col lg="7" md="12">
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Aniversariantes de hoje ({lista.length})</CardTitle>
            </CardHeader>
            <CardBody>
              {lista.map((e, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0", borderBottom: "1px solid rgba(255,255,255,.06)" }}>
                  <div style={{ width: 44, height: 44, borderRadius: 12, background: "#1d8cf8", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", flexShrink: 0 }}>
                    <i className="tim-icons icon-bank" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <p className="text-white" style={{ margin: 0, fontWeight: 500 }}>
                      {e.nome} {e.anos ? <Badge color="warning" pill>{e.anos} anos</Badge> : null}
                    </p>
                    <p className="text-muted" style={{ margin: 0, fontSize: 12 }}>
                      {e.ramo} · {e.municipio}/{e.uf}
                    </p>
                  </div>
                  {e.whatsapp ? (
                    <Button color="success" size="sm" tag="a" target="_blank"
                      href={"https://wa.me/" + e.whatsapp + "?text=" + encodeURIComponent(MODELO.replace("[nome]", e.nome))}>
                      <i className="fab fa-whatsapp" /> Felicitar
                    </Button>
                  ) : (
                    <Button color="info" size="sm" tag="a" href={"tel:+55" + e.telefone}>
                      <i className="tim-icons icon-mobile" /> Ligar
                    </Button>
                  )}
                </div>
              ))}
              {lista.length === 0 && (
                <p className="text-muted">Nenhuma empresa carregada ainda. Aguarde o processamento da base.</p>
              )}
            </CardBody>
          </Card>
        </Col>

        <Col lg="5" md="12">
          <Card>
            <CardHeader><CardTitle tag="h4">Mensagem de networking</CardTitle></CardHeader>
            <CardBody>
              <div style={{ background: "rgba(29,140,248,.08)", borderLeft: "3px solid #1d8cf8", borderRadius: "0 8px 8px 0", padding: "12px 16px" }}>
                <p className="text-white" style={{ margin: 0, fontSize: 14, lineHeight: 1.6 }}>{MODELO}</p>
              </div>
              <p className="text-muted" style={{ fontSize: 12, marginTop: 12 }}>
                O botão "Felicitar" já abre o WhatsApp da empresa com essa mensagem pronta (troca [nome] pelo nome dela). Você só confere e envia.
              </p>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default NetworkingEmpresas;
